import React, { useState, useEffect } from "react";
import { Dialog } from "@mui/material";
import axios from "axios";
import { baseurl } from "../../config/url";
import { showErrorToast, showSuccessToast } from "../../utils/toaster";
import Loader from "../Loader";
import BankDetailsForm from "./BankDetailsForm";

const OrderCancellationDialog = ({
  open,
  onClose,
  fetchOrders,
  selectedtracking,
  status
}) => {
  console.log(selectedtracking)
  const [selectedReason, setSelectedReason] = useState(""); // Store the selected cancellation reason
  const [customReason, setCustomReason] = useState(""); // Store the custom reason if selected
  const [refundCharges, setRefundCharges] = useState(null); // Refund charges fetched from API
  const [loader, setLoader] = useState(false);

  const [bankDetails, setBankDetails] = useState({
    accountHolderName: "",
    accountNumber: "",
    ifscCode: "",
    bankName: "",
    branchName: "",
  });

  useEffect(() => {
    // Fetch refund charges when the dialog opens
    if (open) {
      fetchRefundCharges();
    }
  }, [open]);

  // Function to fetch refund charges
  const fetchRefundCharges = async () => {
    setLoader(true);
    try {
      const response = await axios.get(
        `${baseurl}/api/order-tracking/refund-charges/${selectedtracking?._id}`
      );
      setRefundCharges(response?.data?.refundAmount || 0); // Set the refund charges data
    } catch (error) {
      showErrorToast("Failed to fetch refund charges. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  const handleCancelAndRefund = async () => {
    if (
      !selectedReason.trim() ||
      (selectedReason === "Other" && !customReason.trim())
    ) {
      showErrorToast("Please provide a reason for cancellation.");
      return;
    }

    setLoader(true);

    const reason = selectedReason === "Other" ? customReason : selectedReason;

    // Body for cancellation API
    const cancelBody = { status: "Cancelled", reason };

    // Map status to type for refund API
    const statusToTypeMap = {
      Pending: "Cancellation Before Confirmation",
      Confirmed: "Cancellation After Confirmation",
      Shipped: "Cancellation After Order Shipped",
      Delivered: "Material Rejected or Specification Mismatch",
    };
    // Get the status from the last index of the statusUpdates array
    const lastStatus = selectedtracking?.statusUpdates?.at(-1)?.status || "Unknown Status";

    // Map the status to the refund type
    const refundType = statusToTypeMap[lastStatus] || "Unknown Status";
    // Body for refund API
    const refundBody = {
      orderTrackingId: selectedtracking?._id,
      type: refundType,
      reason,
    };

    try {
      const token = localStorage.getItem("token");

      // Make both API calls concurrently
      await Promise.all([
        axios.put(
          `${baseurl}/api/order-tracking/update-ordertracking/${selectedtracking?._id}`,
          cancelBody,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        ),
        axios.post(`${baseurl}/api/order-tracking/refubd`, refundBody, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      // Fetch updated orders and show success messages
      fetchOrders();
      showSuccessToast("Order has been successfully cancelled and refund updated.");
    } catch (error) {
      showErrorToast("Error processing the request. Please try again.");
    } finally {
      setLoader(false);
      setSelectedReason("");
      setCustomReason("");
      onClose();
    }
  };



  if (!open) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="bg-white rounded-lg shadow-xl w-full p-6">
        <div className="text-2xl font-semibold text-center text-gray-800 mb-6">
          Cancel Order
        </div>
        <div>
          <div className="mb-6">
            {/* <h3 className="text-lg font-medium mb-2 text-gray-700">
              Refund Details:
            </h3> */}
            {refundCharges ? (
              <>
                <p className="text-gray-600">
                  <strong>Refund Amount:</strong> ₹{refundCharges}
                </p>
              </>
            ) : (
              <p className="text-gray-600">Loading refund details...</p>
            )}
          </div>

          <p className="mb-4 text-gray-700">
            Please select a reason for canceling the order:
          </p>
          <div className="space-y-3 mb-3">
            {[
              "Item out of stock",
              "Order error",
              "Changed my mind",
              "Other",
            ].map((reason) => (
              <label key={reason} className="flex items-center text-gray-700">
                <input
                  type="radio"
                  value={reason}
                  checked={selectedReason === reason}
                  onChange={(e) => setSelectedReason(e.target.value)}
                  className="mr-3 accent-blue-500"
                />
                {reason}
              </label>
            ))}
          </div>
          {selectedReason === "Other" && (
            <div className="my-2">
              <input
                type="text"
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
                className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 w-full"
                placeholder="Please specify reason"
              />
            </div>
          )}
        </div>
        {/* <BankDetailsForm bankDetails={bankDetails} setBankDetails={setBankDetails} /> */}
        <div className="pt-6 flex justify-between items-center">
          <button
            onClick={onClose}
            className="bg-gray-300 text-black py-2 px-6 rounded-lg hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleCancelAndRefund}
            className={`py-2 px-6 rounded-lg ${!selectedReason ? "bg-blue-500 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"} text-white`}
            disabled={!selectedReason}
          >
            {loader ? <Loader /> : "Confirm Cancellation"}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default OrderCancellationDialog;
